import {
	AuthenticationContext,
	AuthenticationContextStoreState,
} from '../types/authenticationContext.types';

export const selectAuthenticationContext = (
	state: AuthenticationContextStoreState,
): AuthenticationContext => state.authenticationContext;

export const selectTeams = (state: AuthenticationContextStoreState) =>
	selectAuthenticationContext(state)?.teams ?? [];

export const selectProjects = (state: AuthenticationContextStoreState) =>
	selectAuthenticationContext(state)?.projects ?? {};

export const selectCompanies = (state: AuthenticationContextStoreState) =>
	selectAuthenticationContext(state)?.companies ?? {};
